export const DATA_TABLE_NO_VALUE = '一';